module.exports = __webpack_public_path__ + "img/livemap_map.6f64e5a7.png";